var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.4,
    fill: "#00A0F3",
    stroke: "#00A0F3",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8683 7.07938L11.4264 7.52649C11.3218 7.63231 11.3218 7.80389 11.4264 7.90973L14.8891 11.4129L7.26786 11.4129C7.11993 11.4129 7 11.5342 7 11.6839L7 12.3162C7 12.4658 7.11993 12.5871 7.26786 12.5871L14.8891 12.5871L11.4264 16.0903C11.3218 16.1961 11.3218 16.3677 11.4264 16.4736L11.8683 16.9206C11.9729 17.0265 12.1425 17.0265 12.2471 16.9206L16.9216 12.1916C17.0261 12.0858 17.0261 11.9142 16.9216 11.8084L12.2471 7.07936C12.1425 6.97354 11.9729 6.97354 11.8683 7.07938Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowBlue);
export default __webpack_public_path__ + "static/media/Circle-arrow-blue.5688a8ef.svg";
export { ForwardRef as ReactComponent };